<template>
    <div class="contenedor_modal_2">
        <div class="contenedor_cuerpo_2">
            <div class="contenedor_cabecera_2">
                <button type="button" class="btn btn-sm btn-danger" @click="cerrar"><i
                        class="fas fa-times"></i></button>
            </div>
            <div class="contenedor_contenido_2">
                <b-container fluid="">
                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3>
                                Detalle
                            </h3>
                        </div>
                        <div class="col-sm-12 mt-2">
                            Comentario: {{ item.comentarios }}
                        </div>

                        <div class="col-sm-12 mt-3">
                            <div class="marco_detalle_memrma">
                                <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                                    <thead>
                                        <tr>
                                            <th style="width: 75%;">
                                                Nombre
                                            </th>
                                            <th style="width: 15%;text-align: center;">
                                                Código
                                            </th>
                                            <th style="width: 10%;text-align: center;">
                                                Cantidad
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, index) in item.detalle" :key="index">
                                            <td>
                                                {{ item.nombre }}
                                            </td>
                                            <td style="text-align: center;">
                                                {{ item.codigo }}
                                            </td>
                                            <td style="text-align: center;">
                                                {{ item.cantidad }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </b-row>
                </b-container>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'DetalleMermaRegistrada',
        props: ['item'],
        data() {
            return {

            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            }
        }
    }
</script>

<style>
    .contenedor_modal_2 {
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.2);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .contenedor_cuerpo_2 {
        width: 700px;
        height: 600px;
        background-color: white;
        border-radius: 4px;
    }

    .contenedor_cabecera_2 {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #e9e9e9;
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        padding-right: 10px;
    }

    .marco_detalle_memrma {
        width: 100%;
        height: 440px;
        overflow: auto;
    }

</style>